
import * as Sentry from "@sentry/react";
import React from "react";
import { Integrations } from "@sentry/tracing";
import { Provider } from "react-redux";
import { store } from "./src/redux/store/setup";

import PreRoutes from "./src/navigation/preRoutes.js";
import * as Font from "expo-font";
import {  onMessage } from "firebase/messaging";
import { messaging } from "./src/helpers/firebase";
import { registerServiceWorker } from "./web/register-service-worker";
import { initVersionManager } from "./src/helpers/versionManager";
const REACT_APP_ONE_SIGNAL_APP_ID = "c4d34844-6456-4f6e-9d5a-24cc17842b85";
import { ThemeProvider, Global, css } from '@emotion/react';
import Loader from "./src/commonComponents/activityIndicator/activityIndicator.web";
import { getTokens } from "./openbrix-design-system/design-tokens/color-tokens";
import { GOOGELELOGIKEY } from "./src/helpers/connectionHelpers";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import { Appearance } from "react-native";

Sentry.init({
  dsn: "https://2e11f00c33a94a01802f007ebb8b44ce@o533323.ingest.sentry.io/5652865",
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.sentry_env || "unknown_sentry_env",
  tracesSampleRate: 1.0,
});


let customFonts = {
  "Inter": require("./src/assets/fonts/Inter-Regular.ttf"),
  "Inter-Regular": require("./src/assets/fonts/Inter-Regular.ttf"),
  "Inter-Medium": require("./src/assets/fonts/Inter-SemiBold.ttf"),
  "Inter-SemiBold": require("./src/assets/fonts/Inter-SemiBold.ttf"),
  "Inter-Bold": require("./src/assets/fonts/Inter-Bold.ttf"),
};

export default class App extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isDarkMode: false,
    };
    this.handleDarkModeChange = this.handleDarkModeChange.bind(this);

  }
  async _loadFontsAsync() {
    await Font.loadAsync(customFonts);
  }
  
  
  async componentDidMount() {
    this.cleanupVersionManager = initVersionManager();
    registerServiceWorker();
    onMessage(messaging, (payload) => {
      console.log("Message received. ", JSON.stringify(payload));
      
      // const notificationTitle = payload.notification.title;
      // const notificationOptions = {
      //   body: payload.notification.body,
      //   icon: payload.notification.image,
      // };
    
      // self.registration.showNotification(notificationTitle, notificationOptions);
      
    });
  }

  componentWillUnmount() {
    if (this.cleanupVersionManager) {
      this.cleanupVersionManager();
    }
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    darkModeMediaQuery.removeListener(this.handleDarkModeChange);
  }


  handleDarkModeChange(e) {
    this.setState({ isDarkMode: e.matches });
  };
  
  
  async componentDidMount() {
    console.log("isDarkMode",this.state.isDarkMode);

    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.setState({ isDarkMode: darkModeMediaQuery.matches });
    darkModeMediaQuery.addListener(this.handleDarkModeChange);
    this._loadFontsAsync();
  }


  render() {
    return (
      <GoogleOAuthProvider clientId={GOOGELELOGIKEY}>
      <ThemeProvider theme={getTokens(this.state.isDarkMode ? 'dark' : 'light')}>
        <Global
          styles={css`
            body, html, input, button, select, textarea, div, span, p, a, h1, h2, h3, h4, h5, h6 {
              font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
            }
          `}
        />
        <Provider store={store}>
          <PreRoutes/>
          {/* Control is transferred to Preroutes in order to get time after the strore is configure here } */}
        </Provider>
      </ThemeProvider>
      </GoogleOAuthProvider>
    );
  }
}

